import theme from '../theme';

export const inlineDisplayBreak = theme.breakpoints.mobileBreak + 'em';
